/**
 * The platform's "now" in the browser: the device clock corrected by the server's clock.
 *
 * Every API response carries `X-Server-Now` (docs/features/quote-to-invoice-e2e-testing/03_clock_spec.md
 * §5). In production that only corrects device clock drift; in a testing preview it carries the
 * fast-forwarded time, so due / overdue / "ago" labels follow the preview. Date logic that means
 * "now" reads `currentTime()`, never `new Date()` or `Date.now()`.
 */

let serverOffsetMs = 0;

/** Record the server's time from a response's `X-Server-Now` header (ignored when absent or invalid). */
export function recordServerNow(
  headerValue: string | null,
  deviceNowMs: number = Date.now(),
): void {
  if (!headerValue) return;
  const serverMs = Date.parse(headerValue);
  if (Number.isNaN(serverMs)) return;
  serverOffsetMs = serverMs - deviceNowMs;
}

/** The current platform time. */
export function currentTime(): Date {
  return new Date(Date.now() + serverOffsetMs);
}

/** Test support: forget any recorded server offset. */
export function resetServerNowForTests(): void {
  serverOffsetMs = 0;
}
